import { createGlobalStyle } from 'styled-components'

const AppGlobalFontStyles = createGlobalStyle`
    @font-face {
        font-family: 'Poppins';
        font-style: normal;
        font-weight: ${({ theme }) => theme.fontWeightRegular};
        src: local('Poppins'),
            url('/fonts/Poppins-Regular.woff2') format('woff2'),
            url('/fonts/Poppins-Regular.woff') format('woff');
    }
    @font-face {
        font-family: 'Poppins';
        font-style: italic;
        font-weight: ${({ theme }) => theme.fontWeightRegular};
        src: local('Poppins Italic'),
            url('/fonts/Poppins-Italic.woff2') format('woff2'),
            url('/fonts/Poppins-Italic.woff') format('woff');
    }
    @font-face {
        font-family: 'Poppins';
        font-style: normal;
        font-weight: ${({ theme }) => theme.fontWeightThin};
        src: local('Poppins Thin'),
            url('/fonts/Poppins-Thin.woff2') format('woff2'),
            url('/fonts/Poppins-Thin.woff') format('woff');
    }
    @font-face {
        font-family: 'Poppins';
        font-style: italic;
        font-weight: ${({ theme }) => theme.fontWeightThin};
        src: local('Poppins Thin Italic'),
            url('/fonts/Poppins-ThinItalic.woff2') format('woff2'),
            url('/fonts/Poppins-ThinItalic.woff') format('woff');
    }
    @font-face {
        font-family: 'Poppins';
        font-style: normal;
        font-weight: ${({ theme }) => theme.fontWeightExtraLight};
        src: local('Poppins ExtraLight'),
            url('/fonts/Poppins-ExtraLight.woff2') format('woff2'),
            url('/fonts/Poppins-ExtraLight.woff') format('woff');
    }
    @font-face {
        font-family: 'Poppins';
        font-style: italic;
        font-weight: ${({ theme }) => theme.fontWeightExtraLight};
        src: local('Poppins ExtraLight Italic'),
            url('/fonts/Poppins-ExtraLightItalic.woff2') format('woff2'),
            url('/fonts/Poppins-ExtraLightItalic.woff') format('woff');
    }
    @font-face {
        font-family: 'Poppins';
        font-style: normal;
        font-weight: ${({ theme }) => theme.fontWeightLight};
        src: local('Poppins Light'),
            url('/fonts/Poppins-Light.woff2') format('woff2'),
            url('/fonts/Poppins-Light.woff') format('woff');
    }
    @font-face {
        font-family: 'Poppins';
        font-style: italic;
        font-weight: ${({ theme }) => theme.fontWeightLight};
        src: local('Poppins Light Italic'),
            url('/fonts/Poppins-LightItalic.woff2') format('woff2'),
            url('/fonts/Poppins-LightItalic.woff') format('woff');
    }
    @font-face {
        font-family: 'Poppins';
        font-style: normal;
        font-weight: ${({ theme }) => theme.fontWeightMedium};
        src: local('Poppins Medium'),
            url('/fonts/Poppins-Medium.woff2') format('woff2'),
            url('/fonts/Poppins-Medium.woff') format('woff');
    }
    @font-face {
        font-family: 'Poppins';
        font-style: italic;
        font-weight: ${({ theme }) => theme.fontWeightMedium};
        src: local('Poppins Medium Italic'),
            url('/fonts/Poppins-MediumItalic.woff2') format('woff2'),
            url('/fonts/Poppins-MediumItalic.woff') format('woff');
    }
    @font-face {
        font-family: 'Poppins';
        font-style: normal;
        font-weight: ${({ theme }) => theme.fontWeightSemiBold};
        src: local('Poppins SemiBold'),
            url('/fonts/Poppins-SemiBold.woff2') format('woff2'),
            url('/fonts/Poppins-SemiBold.woff') format('woff');
    }
    @font-face {
        font-family: 'Poppins';
        font-style: italic;
        font-weight: ${({ theme }) => theme.fontWeightSemiBold};
        src: local('Poppins SemiBold Italic'),
            url('/fonts/Poppins-SemiBoldItalic.woff2') format('woff2'),
            url('/fonts/Poppins-SemiBoldItalic.woff') format('woff');
    }
    @font-face {
        font-family: 'Poppins';
        font-style: normal;
        font-weight: ${({ theme }) => theme.fontWeightBold};
        src: local('Poppins Bold'),
            url('/fonts/Poppins-Bold.woff2') format('woff2'),
            url('/fonts/Poppins-Bold.woff') format('woff');
    }
    @font-face {
        font-family: 'Poppins';
        font-style: italic;
        font-weight: ${({ theme }) => theme.fontWeightBold};
        src: local('Poppins Bold Italic'),
            url('/fonts/Poppins-BoldItalic.woff2') format('woff2'),
            url('/fonts/Poppins-BoldItalic.woff') format('woff');
    }
    @font-face {
        font-family: 'Poppins';
        font-style: normal;
        font-weight: ${({ theme }) => theme.fontWeightExtraBold};
        src: local('Poppins ExtraBold'),
            url('/fonts/Poppins-ExtraBold.woff2') format('woff2'),
            url('/fonts/Poppins-ExtraBold.woff') format('woff');
    }
    @font-face {
        font-family: 'Poppins';
        font-style: italic;
        font-weight: ${({ theme }) => theme.fontWeightExtraBold};
        src: local('Poppins ExtraBold Italic'),
            url('/fonts/Poppins-ExtraBoldItalic.woff2') format('woff2'),
            url('/fonts/Poppins-ExtraBoldItalic.woff') format('woff');
    }
    @font-face {
        font-family: 'Poppins';
        font-style: normal;
        font-weight: ${({ theme }) => theme.fontWeightBlack};
        src: local('Poppins Black'),
            url('/fonts/Poppins-Black.woff2') format('woff2'),
            url('/fonts/Poppins-Black.woff') format('woff');
    }
    @font-face {
        font-family: 'Poppins';
        font-style: italic;
        font-weight: ${({ theme }) => theme.fontWeightBlack};
        src: local('Poppins Black Italic'),
            url('/fonts/Poppins-BlackItalic.woff2') format('woff2'),
            url('/fonts/Poppins-BlackItalic.woff') format('woff');
    }
`

export default AppGlobalFontStyles
